import { useMemo } from 'react';

import { useFromInput } from '../../../hooks/useFromInput';
import { useMarketPrice } from '../../../hooks/useMarketPrice';
import { useIsLeverageMaxReached } from '../../TradeModuleConfirm/hooks/useIsLeverageMaxReached';
import { useIsLong } from '../store/useIsLong';
import { validateTriggerPrice } from '../utils/validateTriggerPrice';
import { usePositionSize } from './usePositionSize';

export const useTriggerPriceInputValidation = () => {
  const isLong = useIsLong((s) => s._persistValue);
  const input = useFromInput((s) => s.input);

  const marketPrice = useMarketPrice();
  const positionSize = usePositionSize({
    inputUsd: input.value.usd,
    isBeforeFee: false,
  });

  const isLeverageReachMax = useIsLeverageMaxReached();

  return useMemo(() => {
    return validateTriggerPrice({
      isLong,
      marketPrice: marketPrice,
      triggerPrice: input.triggerPrice,
      isLeverageReachMax,
      positionSizeUsd: positionSize,
    });
  }, [
    input.triggerPrice,
    isLeverageReachMax,
    isLong,
    marketPrice,
    positionSize,
  ]);
};
